import { observer } from "mobx-react-lite";
import React from "react";
import { AccountSheetActive } from "../../plans/PlanModel";
import { accountVerifyPasswordCode, signOutFromApp } from "../firebaseInit";
import { useStores } from "../stores";
import { AccountForgotPasswordSheet } from "./AccountForgotPasswordSheet";
import { AccountLoginSheet } from "./AccountLoginSheet";
import { AccountRegisterSheet } from "./AccountRegisterSheet";
import { AccountSetPasswordSheet } from "./AccountSetPasswordSheet";

export const LoginSheets = observer(
  ({
    currentSheet,
    onChangeSheet,
    onCurrentSheetDone,
  }: {
    currentSheet: AccountSheetActive;
    onChangeSheet: (sheet: AccountSheetActive) => void;
    onCurrentSheetDone?: () => void;
  }) => {
    const { sessionStore } = useStores();

    const [showSetPassword, setShowSetPassword] = React.useState(false);

    React.useEffect(() => {
      const queryParameters = new URLSearchParams(window.location.search);
      const _continueUrl = queryParameters.get("continueUrl");
      const mode = queryParameters.get("mode");
      const oobCode = queryParameters.get("oobCode");

      const checkCode = async () => {
        if (oobCode && (await accountVerifyPasswordCode(oobCode))) {
          if (sessionStore.isLoggedIn) {
            // First log out user,
            await signOutFromApp(false);
          }

          setShowSetPassword(true);
        }
      };

      if (!showSetPassword && mode === "resetPassword") {
        void checkCode();
      }
    }, [showSetPassword, sessionStore]);

    const onChangeSheetAction = React.useCallback(
      (s: AccountSheetActive) => {
        setShowSetPassword(false);
        onChangeSheet?.(s);
      },
      [onChangeSheet],
    );

    return (
      <>
        <AccountLoginSheet
          open={currentSheet === AccountSheetActive.Login && !showSetPassword}
          onChangeSheet={onChangeSheetAction}
          onLoginDone={onCurrentSheetDone}
        />
        <AccountRegisterSheet
          open={
            currentSheet === AccountSheetActive.Register && !showSetPassword
          }
          onChangeSheet={onChangeSheetAction}
          onRegisterDone={onCurrentSheetDone}
        />
        <AccountForgotPasswordSheet
          open={
            currentSheet === AccountSheetActive.ForgotPassword &&
            !showSetPassword
          }
          onChangeSheet={onChangeSheetAction}
        />
        <AccountSetPasswordSheet
          open={
            currentSheet === AccountSheetActive.SetPassword || showSetPassword
          }
          onChangeSheet={onChangeSheetAction}
        />
      </>
    );
  },
);
